// Transport Request Status Enums
// These match the backend RequestStatusEnum.cs values
export const REQUEST_STATUS = {
  PENDING: 1,
  APPROVED: 2,
  CANCELLED: 3,
  COMPLETE: 4,
};

export const REQUEST_STATUS_NAMES = {
  [REQUEST_STATUS.PENDING]: 'Pending',
  [REQUEST_STATUS.APPROVED]: 'Approved',
  [REQUEST_STATUS.CANCELLED]: 'Cancelled',
  [REQUEST_STATUS.COMPLETE]: 'Complete',
};

const STATUS_COLORS = {
  [REQUEST_STATUS.PENDING]: { base: '#F0C44C', hover: '#E6B93F' },
  [REQUEST_STATUS.APPROVED]: { base: '#6FA8F5', hover: '#5F97E6' },
  [REQUEST_STATUS.CANCELLED]: { base: '#E5737A', hover: '#DA636A' },
  [REQUEST_STATUS.COMPLETE]: { base: '#86C26A', hover: '#78B85D' },
};

const DEFAULT_STATUS_COLOR = STATUS_COLORS[REQUEST_STATUS.PENDING];

export const getStatusColor = (statusId) => (STATUS_COLORS[statusId] || DEFAULT_STATUS_COLOR).base;
export const getStatusHoverColor = (statusId) => (STATUS_COLORS[statusId] || DEFAULT_STATUS_COLOR).hover;

export const STATUS_BUTTONS_ACTION_CONFIG = {
  cancel: {
    status: REQUEST_STATUS.CANCELLED,
    label: 'Cancel Request',
    dialog: 'Are you sure you want to cancel this transport request?',
    button: 'Yes',
    color: 'error',
    show: (status) => status === REQUEST_STATUS.PENDING || status === REQUEST_STATUS.APPROVED,
    variant: 'outlined',
  },
  approve: {
    status: REQUEST_STATUS.APPROVED,
    label: 'Approve Request',
    dialog: 'Are you sure you want to approve this transport request?',
    button: 'Approve',
    color: 'secondary',
    show: (status) => status === REQUEST_STATUS.PENDING,
    variant: 'contained',
  },
  complete: {
    status: REQUEST_STATUS.COMPLETE,
    label: 'Complete Request',
    dialog: 'Are you sure you want to mark this transport request as complete?',
    button: 'Complete',
    color: 'secondary',
    show: (status) => status === REQUEST_STATUS.APPROVED,
    variant: 'contained',
  },
  reopen: {
    status: REQUEST_STATUS.PENDING,
    label: 'Re-Open Request',
    dialog: 'Are you sure you want to re-open this transport request?',
    button: 'Re-Open',
    color: 'secondary',
    show: (status) => status === REQUEST_STATUS.CANCELLED,
    variant: 'outlined',
  },
};
